<!--
 * @Description: 个别教育记录 添加
 * @Author: ztw
 * @Date: 2023-03-01 15:13:39.345
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-11-28 17:52:44
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="学期" prop="xqid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.xqid" clearable filterable>
                <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="选择学生" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-button class="mr10" type="primary" @click="openDanTiao=true">选择</el-button>
              <el-tag class="mr10 mt10" v-if="ruleForm.xsid" closable @close="CourseClose">{{ruleForm.xsxm}}</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="日期" prop="rq" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="ruleForm.rq" type="date" value-format="YYYY-MM-DD" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="教育情况" prop="jyqk">
              <el-input v-model="ruleForm.jyqk" type="textarea" resize="none" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="效果" prop="xg">
              <el-input v-model="ruleForm.xg" type="textarea" resize="none" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <xueshengdantiao v-if="openDanTiao" v-model:openDanTiao="openDanTiao" :row="row" @ReturnData="ReturnData" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow, loadSelect } from '@/api/common.js'
import xueshengdantiao from '@/components/chazhaodaihui/xueshengdantiao.vue'

const props = defineProps({ openAdd: { type: Boolean, required: true } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const xqData = ref([]) // 学期
// const initSelectList = async () => {
//   getxueqiList().then((res) => {
//     xqData.value = res.data
//     res.data.forEach((element) => {
//       if (element.sfdqxq) {
//         ruleForm.value.xqid = element.id
//       }
//     })
//   })
// }
// 学生单条
const openDanTiao = ref(false)
const ReturnData = (data) => {
  ruleForm.value.xsid = data.id
  ruleForm.value.xsxm = data.xm
}
const CourseClose = () => {
  ruleForm.value.xsid = ''
  ruleForm.value.xsxm = ''
}
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      loadSelect({
        url: '/api/v2/pdp/xueqi/list',
        data: xqData,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          res.data.forEach((element) => {
            if (element.sfdqxq === true) {
              ruleForm.value.xqid = element.id
            }
          })
        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  submitForm({
    url: '/api/v2/xuesheng/banzhurengongzuogebiejiaoyujilu',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openAdd', emits, true)
    }
  })
}
</script>
